import { Modal } from "@sicredi/react";
import { IModalAccountAgency } from "./model";
import { useContext } from "react";
import { ContextAPI } from "#/contextProver/ContextProver";
import { handleRefresh } from "./services";

export const OfertaIndisponivelModal: React.FC<IModalAccountAgency> = ({
  isOpen,
  setIsOpen,
  isLogout = true,
  handleOnClick = () => {},
}) => {
  const { logout } = useContext(ContextAPI);

  const handleButton = async () => {
    if (isLogout) {
      return await handleRefresh(setIsOpen, logout);
    } else {
      handleOnClick();
      setIsOpen(false);
    }
  };

  return (
    <div>
      <Modal
        title="Oferta indisponível"
        onClose={async () => await handleButton()}
        show={isOpen}
        primaryButton={{
          children: "Entendi",
          onClick: async () => await handleButton(),
        }}
      >
        Escolha um valor menor para avançar na simulação ou entre em contato com
        sua agência.
      </Modal>
    </div>
  );
};
